import React, { useContext } from 'react';

interface IFollowInstructorContext {
  setFollowState?: (id: string, blockState: object) => void;
  followState?: Record<string, object>;
}

export const FollowInstructorContext = React.createContext<Partial<IFollowInstructorContext>>({
  setFollowState: () => {},
});

export const useFollowInstructorContext = () => useContext(FollowInstructorContext);
